import { render } from "./DeleteAccount.vue?vue&type=template&id=01c3faff&scoped=true&lang=pug"
import script from "./DeleteAccount.vue?vue&type=script&lang=ts"
export * from "./DeleteAccount.vue?vue&type=script&lang=ts"

import "./DeleteAccount.vue?vue&type=style&index=0&id=01c3faff&lang=css"
import "./DeleteAccount.vue?vue&type=style&index=1&id=01c3faff&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01c3faff"

export default script